<template>
<div>
    <div class="topbar">
      <i @click="goHome"></i>
        <!-- <span>{{$t('nav_name')}}</span> -->
        <div class="mainBox1">
          <div class="changeLangBtn" @click.stop="moreLang()">
            {{ $t("language") }}
            <em class="iconfont icon-een"></em>
            <ul v-show="changeLangBox" class="chooseLangUl">
              <li v-for="(item,index) in langList" class="chooseLangUlli" :key="index" @click="setLanguage(item.id)">{{item.name}}</li>
            </ul>
          </div>
          <div class="changeLangBtn1" @click.stop="goLogin()">{{$t('homepage_button1')}}</div>
        </div>
    </div>
    <div class="banner">
      <div class="forget">
        <div class="forgetPsd" >{{$t('verifyFail_title')}}</div>
        <!-- <span class="line"></span>  -->
            <div class="content content3">{{$t('emailVerify_txt1')}}</div>
            <button class="signIn" @click="sucess">{{$t('emailVerify_button')}}</button>
            <div class="content content2">{{$t('emailVerify_txt2')}}</div>
            <div class="send" v-show="allMsg" v-text="warinningText"></div>
            <div v-show="showMsg" class="content content1">{{$t('emailVerify_note')}}</div>
      </div>
    </div>
</div>
</template>

<script>
import I18nUtils from "@/utils/i18nUtils";

export default {
  name: 'unableLink',
  data () {
    return {
      showMsg:false,
      warinningText:'',
      allMsg:false,
      changeLangBox:false,
      langList: I18nUtils.langList,
    }
  },
  mounted () {
    I18nUtils.initLanguage(this);
    this.warinningText = this.$t('bad_network')
  },
  watch: {

  },
  methods: {
    setLanguage(lang) {
      I18nUtils.updateDivLanguage(lang);
      I18nUtils.setLanguage(this, lang);
    },
    
    sucess(){
        var userArea = ''
        if(this.$i18n.locale == 'zh'){
          userArea = '1'
        }else if(this.$i18n.locale == 'en'){
          userArea = '2'
        }else if(this.$i18n.locale == 'sp'){
          userArea = '3'
        }else if(this.$i18n.locale == 'fr'){
          userArea = '4'
        }
        this.$http.getAxios('/sms/sendForgetPwdEmail', {
          method: 'post',
          data: {
            'email': localStorage.getItem('emailComp'),
            'userArea':userArea
          },
        }).then((res) => {
          var res = res.data;
          if(res.code == '0'){
            this.showMsg = true;
          }else if(res.code == '43'){
            this.allMsg = true;
            this.warinningText = this.$t('forPass_note7')
          }else if(res.code == '48'){
            this.allMsg = true;
            this.warinningText = this.$t('forPass_note7')
          }else{
            this.allMsg = true;
            this.warinningText = this.$t('bad_network')
          }
        });
    },
    moreLang(){
      this.changeLangBox = !this.changeLangBox;
    },

    goLogin(){
      this.$router.push({ path:'/signIn'})
    },
    goHome(){
      this.$router.push({ path:'/'})
    },
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped rel="stylesheet/scss" lang="scss">
.topbar{
    width: 100%;
    height: 60px;
    color: #aaf9fe;
    background: #122346;
    i{
      position: absolute;
      top: 8px;
      left: 40px;
      width: 172px;
      height: 46px;
      cursor: pointer;
      z-index: 99999999999999999;
      background: url('~@/assets/images/bigIcon.png') no-repeat center;
    }
}
.topbar span{
    font-size: 20px;
    line-height: 60px;
    margin-left: 100px;
}
.banner{
    width: 1200px;
    margin: 0 auto;
    .forget{
      width: 600px;
      height: 400px;
      position: absolute;
      top:50%;
      left: 50%;
      transform: translate(-50%,-50%);
      text-align: center;
    }
    .forgetPsd{
      margin-left:65px;
      width: 453px;
      height: 58px;
      background: url('~@/assets/images/title.png') no-repeat  center;
      font-size: 38px;
      font-weight: 700;
      line-height: 58px;
      color: #37c2e5;
    }
    .content{
        width: 566px;
        margin: 0 auto;
        text-align: center;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 20px;
        letter-spacing: 0px;
        color: #ffffff;
        margin-top: 50px;
        margin-bottom: 34px;
    }
    .content3{
      text-align: left;
      line-height: 30px;
    }
    .content1{
        margin-top: 23px;
        margin-bottom: 0px;
    }
    .content2{
        margin-top: 57px;
        margin-bottom: 0px;
    }
}
.send{
        font-size: 20px;
	      color: #ff5a00;
        margin-top: 39px;
      }
.signIn{
  width: 461px;
	height: 59px;
	background-color: #2d8c9e;
  border-radius: 29px;
  color: #fff;
  margin: 0 auto;
  border: 0;
  display: block;
  font-size: 20px;
  cursor: pointer;
}
.changeLangBtn{
    cursor: pointer;
    float: right;
    font-weight: normal;
    font-size: 18px;
    line-height: 60px;
  }
  .changeLangBtn1{
    cursor: pointer;
    float: right;
    font-weight: normal;
    font-size: 18px;
    line-height: 60px;
    margin-right: 20px;
  }
  .s11{
    display: block;
    margin-top: 20px;
    font-size: 18px;
    color: red;
}
.chooseLangUl{
    position: absolute;
    z-index: 111;
    li{
      height: 40px;
      cursor: pointer;
    }
  }
.settingBtn,.changeLangBtn{
    cursor: pointer;
    float: right;
    font-weight: normal;
    font-size: 18px;
    padding-right: 20px;
  }
  .mainBox1{
    height: 60px;
    width: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    z-index: 323223;
}

</style>



// WEBPACK FOOTER //
// src/components/unableLink.vue